import Axios, { AxiosInstance } from "axios"
import router from "../router"

export default function() {
  const axios = Axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      "Access-Control-Allow-Origin": `${process.env.VUE_APP_API_URL}`,
      "access-control-allow-headers": "Authorization",
    },
  }) as AxiosInstance

  axios.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem("user-token") as string
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    },
    (err: any) => {
      return Promise.reject(err)
    }
  )

  axios.interceptors.response.use(
    (response: any) => {
      return response
    },
    (error: any) => {
      if (error?.response?.status === 401) {
        router.push("/")
      }
      if (!navigator.onLine) {
        return Promise.reject({
          response: { data: { message: "Você está sem acesso a internet" } },
        })
      }
      return Promise.reject(error)
    }
  )
  return axios
}
